import { Popover, Pressed } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const PopoverStyled = styled(Popover)(() => ({
  marginTop: 19,
  marginLeft: 57,

  [Popover.classes.paper]: {
    width: 400,
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
  } as CSSObject,
}));

export const NotificationPressedStyled = styled(Pressed)(({ theme }) => ({
  '& svg path': {
    strokeWidth: 2,
  } as CSSObject,

  '& svg': {
    transition: theme.transitions.create('color'),
  },

  '&:hover': {
    '& svg': {
      color: Colors.hover,
    } as CSSObject,
  },
}));
